import { useState, useEffect, useCallback, useRef } from 'react';

export const useAutoRefresh = (refreshFunction, intervalMs = 30000) => {
  const [lastRefresh, setLastRefresh] = useState(new Date());
  const intervalRef = useRef(null);
  const refreshFunctionRef = useRef(refreshFunction);

  // Frissítő függvény frissítése
  useEffect(() => {
    refreshFunctionRef.current = refreshFunction;
  }, [refreshFunction]);

  // Automatikus frissítés indítása
  const startAutoRefresh = useCallback(() => {
    if (intervalRef.current) return;

    intervalRef.current = setInterval(async () => {
      try {
        await refreshFunctionRef.current();
        setLastRefresh(new Date());
      } catch (error) {
        console.warn('Auto-refresh hiba:', error);
      }
    }, intervalMs);
  }, [intervalMs]);

  // Automatikus frissítés leállítása
  const stopAutoRefresh = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  // Auto-refresh beállítása
  useEffect(() => {
    startAutoRefresh();

    return () => {
      stopAutoRefresh();
    };
  }, [startAutoRefresh, stopAutoRefresh]);

  return {
    lastRefresh
  };
};
